module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/readable-stream/passthrough.js
// module id = 1709
// module chunks = 1